import * as yup from 'yup';
type TFunction = (key: string, options?: Record<string, unknown>) => string;

export const initialTopUpsRepartition = {
  repartition: undefined,
};

export const topUpsFormRepartitionSchema = (translate: TFunction) => {
  return yup.object().shape({
    repartition: yup
      .array()
      .required(translate('REQUIRED') ?? undefined)
      .of(
        yup.object().shape({
          establishmentId: yup.string().required(translate('REQUIRED')),
          creditsAmount: yup.number().required(translate('REQUIRED')),
        }),
      ),
  });
};
